import { createElement } from '@wordpress/element';
import { TextInput, Toggle, Select, ColorPicker, RadioGroup, RangeSlider } from '../admin/components/ui';

export const renderInputRow = (
    label,
    key,
    type = 'text',
    options = [],
    _checkboxLabel = '',
    Settings = {},
    updateSetting = () => {},
    disabled = false
) => {
    const isToggle = type === 'checkBox';

    return (
        <div key={key} className={`cpiw-field-row${isToggle ? ' cpiw-field-row--toggle' : ''}`}>
            <div className="cpiw-field-label">{label}</div>
            <div className="cpiw-field-control">
                {type === 'checkBox' ? (
                    <Toggle
                        checked={Settings[key] === 'enable'}
                        onChange={(val) => updateSetting(key, val ? 'enable' : 'disable')}
                        label
                    />
                ) : type === 'colorPallete' ? (
                    <ColorPicker
                        value={Settings[key]}
                        onChange={(val) => updateSetting(key, val)}
                    />
                ) : (
                    <TextInput
                        type={type || 'text'}
                        min={type === 'number' ? 0 : undefined}
                        value={Settings[key] || ''}
                        
                        onKeyDown={
                            type === 'number'
                                ? (e) => {
                                    if (e.key === '-' || e.key === 'e') {
                                        e.preventDefault();
                                    }
                                }
                                : undefined
                        }

                        onChange={(val) => {
                            if (type === 'number') {
                                if (val === '' || Number(val) >= 0) {
                                    updateSetting(key, val);
                                }
                            } else {
                                updateSetting(key, val);
                            }
                        }}
                    />
                )}
            </div>
        </div>
    );
};
